package com.exura.features.plandefinition.domain.model.element

import com.exura.features.plandefinition.domain.model.series.HourOfDay
import dev.gitlive.firebase.firestore.CollectionReference

/**
 * Represents a persistent element that spans a period of time.
 * Generated from PersistentSeries.
 * Updated to implement SerializableDomainModel through BasePlanElement.
 */
data class PersistentElement(
    override val firebaseDocId: String? = null,
    override val firebaseDocPrefix: CollectionReference? = null,
    val startRelativeDay: Int,
    val endRelativeDay: Int,
    val startRelativeHourOfDay: HourOfDay? = null,
    val endRelativeHourOfDay: HourOfDay? = null,
    override val title: String,
    val description: String,
    val icon: String? = null,
    override val durationInMinutes: Int = calculateDurationInMinutes(
        startRelativeDay, endRelativeDay,
        startRelativeHourOfDay, endRelativeHourOfDay
    ),
    override val imageUrl: String? = null,
) : BasePlanElement(
    firebaseDocId = firebaseDocId,
    firebaseDocPrefix = firebaseDocPrefix,
    elementType = ElementType.PERSISTENT,
) {
    override val relativeDay: Int = startRelativeDay

    override fun durationInDays(): Int = endRelativeDay - startRelativeDay + 1

    companion object {
        /**
         * Calculates the duration in minutes based on start and end days/times
         */
        private fun calculateDurationInMinutes(
            startDay: Int,
            endDay: Int,
            startHourOfDay: HourOfDay?,
            endHourOfDay: HourOfDay?
        ): Int {
            val daysDifference = endDay - startDay
            val daysInMinutes = daysDifference * 24 * 60

            // Default to start/end of day if hour not specified
            val startMinutes = startHourOfDay?.let { it.hour * 60 + it.minute } ?: 0
            val endMinutes = endHourOfDay?.let { it.hour * 60 + it.minute } ?: (24 * 60)

            return daysInMinutes + (endMinutes - startMinutes)
        }
    }
}
